import _ from 'lodash';

export class ResidentialReportPerformance {
	public overallAvgSavings: number;
	public conversionRate: number;
	public churnRate: number;
	public utilityPerformance: { serviceTypeId: string; utilityName: string; stateShort: string; marketSavings: number }[];
	public supplierPerformance: { supplierName: string; marketSavings: number }[];

	public mostOptimalUtilityMarkets: { serviceTypeId: string; utilityName: string; stateShort: string; marketSavings: number }[];
	public leastOptimalUtilityMarkets: { serviceTypeId: string; utilityName: string; stateShort: string; marketSavings: number }[];
	public mostOptimalSupplierMarkets: { supplierName: string; marketSavings: number }[];
	public leastOptimalSupplierMarkets: { supplierName: string; marketSavings: number }[];

	constructor(residentialReportPerformance: ResidentialReportPerformance) {
		Object.assign(this, residentialReportPerformance);
		this.mostOptimalUtilityMarkets = _.take(
			this.utilityPerformance.filter(u => u.marketSavings > 0),
			5,
		);
		this.leastOptimalUtilityMarkets = _.takeRight(
			_.xorBy(this.utilityPerformance, this.mostOptimalUtilityMarkets, u => u.serviceTypeId + u.utilityName + u.stateShort),
			5,
		);
		this.mostOptimalSupplierMarkets = _.take(
			this.supplierPerformance.filter(s => s.marketSavings > 0),
			5,
		);
		this.leastOptimalSupplierMarkets = _.takeRight(
			_.xorBy(this.supplierPerformance, this.mostOptimalSupplierMarkets, u => u.supplierName),
			5,
		);
	}
}
